import { api } from "@/lib/api";

export async function listWorkers() {
  const { data } = await api.get("/workers");
  return data;
}
export async function getWorker(id) {
  const { data } = await api.get(`/workers/${id}`);
  return data;
}
export async function createWorker(payload) {
  const { data } = await api.post("/workers", payload);
  return data;
}
export async function updateWorker(id, payload) {
  const { data } = await api.put(`/workers/${id}`, payload);
  return data;
}
export async function deleteWorker(id) {
  const { data } = await api.delete(`/workers/${id}`);
  return data;
}
export async function getWorkerAnalyses(id) {
  const { data } = await api.get(`/workers/${id}/analyses`);
  return data;
}
